.root {
  padding-top: 1.5rem;
  border-top: 1px solid var(--gray-400);

  input {
    margin-bottom: 0;
  }
}

.minMax {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}
